import { useSearchParams } from 'react-router-dom';
import { useCallback } from 'react';

export const SEARCH_QUERY_ID_PARAM = 'searchQueryId';

/**
 * Manages searchQueryId persistence in URL parameters.
 * Provides methods to read, update, and clear the search query ID from the URL.
 */
export const useSearchQueryPersistence = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchQueryId = searchParams.get(SEARCH_QUERY_ID_PARAM);

  const updateSearchQueryId = useCallback(
    (id: string): void => {
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set(SEARCH_QUERY_ID_PARAM, id);
      const newParamsString = currentParams.toString();
      setSearchParams(newParamsString, {
        state: {
          shallow: true
        },
        replace: true
      });
    },
    [setSearchParams]
  );

  const clearSearchQueryId = useCallback((): void => {
    if (searchQueryId) {
      setSearchParams(new URLSearchParams(), {
        state: {
          shallow: true
        },
        replace: true
      });
    }
  }, [searchQueryId, setSearchParams]);

  return {
    searchQueryId,
    updateSearchQueryId,
    clearSearchQueryId
  };
};
